import { useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import styles from './Winners.module.css';
import hum from '../../assets/images/hum.png';
import confetti from '../../assets/images/confetti.gif';
import { hideNumber } from '../../helpers/titreHelper';
import { useGetParams } from '../../hooks/useGetParams';
import { Star } from './Star';

export const Winners = ({ winnerMessages }) => {
  const { winnerTitleFontSize, winnerSize, winnerFontSize } = useGetParams();
  const confettiRef = useRef(null);

  const errorHandler = (e) => {
    e.target.src = hum;
  };

  useEffect(() => {
    let idTimeout = '';
    if (confettiRef.current) {
      idTimeout = setTimeout(() => {
        confettiRef.current.style.display = 'block';
      }, 2500);
    }
    return () => {
      clearTimeout(idTimeout);
    };
  }, [confettiRef]);

  return (
    <div className={styles.winnersContainer}>
      <motion.div
        initial={{ opacity: 0, y: -1000 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.5, delay: 1, ease: 'easeIn' }}
        className={styles.title}
      >
        <h1 style={{ fontSize: `${winnerTitleFontSize}rem` }}>
          {'Победитель'}
        </h1>
      </motion.div>

      <div className={styles.starsBlock}>
        <motion.div
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 3 }}
          transition={{ duration: 0.5, delay: 1.5, ease: 'easeIn' }}
        >
          <Star size={24} color="#00FFFF" />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 5 }}
          transition={{ duration: 0.5, delay: 1.8, ease: 'easeIn' }}
        >
          <Star size={24} color="#00FFFF" />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 3 }}
          transition={{ duration: 0.5, delay: 2.1, ease: 'easeIn' }}
        >
          <Star size={24} color="#00FFFF" />
        </motion.div>
      </div>

      <div className={styles.winnersBlock}>
        <AnimatePresence>
          {winnerMessages &&
            winnerMessages.slice(0, 1).map((win, i) => {
              const [name, surname] = win.message?.author
                ?.trim()
                ?.split(' ')
                .map((s) => s?.trim());
              return (
                <>
                  <motion.div
                    key={win.id}
                    initial={{ opacity: 0, scale: 0 }}
                    exit={{ opacity: 0, scale: 0 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 1, delay: 1, ease: 'easeIn' }}
                    className={styles.m}
                  >
                    <div className={styles.winnerItem}>
                      <div className={styles.winnerImageContainer}>
                        <svg
                          className={styles.circle1}
                          xmlns="http://www.w3.org/2000/svg"
                          width={`${winnerSize * 1.15}rem`}
                          height={`${winnerSize * 1.15}rem`}
                          style={{
                            transform: `translate(-${winnerSize * 0.075}rem, -${
                              winnerSize * 0.075
                            }rem)`,
                          }}
                          fill="none"
                          viewBox="0 0 188 188"
                        >
                          <rect
                            width="187"
                            height="187"
                            x=".5"
                            y=".5"
                            stroke="url(#a)"
                            strokeWidth="2"
                            rx="186"
                            viewBox="0 0 188 188"
                          />
                          <defs>
                            <linearGradient
                              id="a"
                              x1="0"
                              x2="166"
                              y1="0"
                              y2="90.4"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#6DDCFF" />
                              <stop offset="1" stop-color="#002aff" />
                            </linearGradient>
                          </defs>
                        </svg>
                        <svg
                          className={styles.circle2}
                          xmlns="http://www.w3.org/2000/svg"
                          width={`${winnerSize * 1.01}rem`}
                          height={`${winnerSize * 1.01}rem`}
                          style={{
                            transform: `translate(-${winnerSize * 0.005}rem, -${
                              winnerSize * 0.005
                            }rem)`,
                          }}
                          fill="none"
                          viewBox="0 0 188 188"
                        >
                          <rect
                            width="187"
                            height="187"
                            x=".5"
                            y=".5"
                            stroke="url(#a)"
                            strokeWidth="2"
                            rx="187"
                            viewBox="0 0 188 188"
                          />
                          <defs>
                            <linearGradient
                              id="a"
                              x1="0"
                              x2="166"
                              y1="0"
                              y2="90.4"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#6DDCFF" />
                              <stop offset="1" stop-color="#002aff" />
                            </linearGradient>
                          </defs>
                        </svg>
                        <img
                          onError={errorHandler}
                          src={
                            (win.message?.image &&
                              win.message.image !== '1' &&
                              win.message.image) ||
                            hum
                          }
                          style={{
                            width: `${winnerSize}rem`,
                            height: `${winnerSize}rem`,
                          }}
                          alt="avatar"
                          className={styles.avatar}
                        />
                      </div>
                    </div>
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, y: 1000 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1.5, delay: 1, ease: 'easeIn' }}
                    className={styles.name}
                    style={{ fontSize: `${winnerFontSize}rem` }}
                  >
                    {win.message?.author
                      ? `${name}${surname ? ` ${surname[0]}.` : ''}`
                      : hideNumber(win.message?.senderNumber)}
                  </motion.div>
                </>
              );
            })}
        </AnimatePresence>
      </div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2, duration: 1.5, ease: 'easeIn' }}
        className={styles.confetti}
      >
        <img
          src={confetti}
          alt="confetti"
          className={styles.confetti}
          ref={confettiRef}
        />
      </motion.div>
    </div>
  );
};
